<template>
    <modal @close="$emit('close')" modal-width="75%">
        <div slot="header"><h3 style="margin: 0">Notification More Info</h3></div>
        <div slot="body">
            <p>
                <a :href="advertsUrl" class="btn btn-primary" target="_blank">View Adverts</a>
                <a :href="reportsUrl" class="btn btn-primary" target="_blank">View Reports</a>
                <a :href="logsLink" class="btn btn-primary" target="_blank" v-if="hasLogsLink">View Logs</a>
            </p>
            <p><strong>Date: </strong> {{ notification.created_at }}</p>
            <p><strong>Agency: </strong> {{ notification.agency.name }} ({{ notification.agency.id }})</p>
            <p><strong>Type: </strong> {{ notification.type }}</p>
            <p><strong>Text: </strong> {{ notification.text }} <a v-if="notification.data.link"
                                                                  v-bind:href="notification.data.link">{{
                    notification.data.link
                }}</a></p>
            <p>
                <strong>Status: </strong>

                <span class="form-inline">
                    <select v-model="notification.status_id" class="form-control" style="max-width: 200px;"
                            @change.prevent="saveStatus">
                        <option v-for="status in statuses" :value="status.id">{{ status.label }}</option>
                    </select>
                </span>
                <i class="fa fa-sync-alt fa-spin" v-if="isSavingStatus"></i>
            </p>

            <p>
                <strong>Snooze: </strong>

                <span class="form-inline">
                <select class="form-control" v-model="snooze_select_days" @change="saveSnooze(notification)">
                    <option value="">{{ this.snoozed_until_days ? ("(" + this.snoozed_until_days + " days)") : '' }}</option>
                    <option v-if="snooze_select_days > 0 || snoozed_until_days > 0" value="0">(delete)</option>
                    <option value="1">1d</option>
                    <option value="2">2d</option>
                    <option value="3">3d</option>
                    <option value="5">5d</option>
                    <option value="7">7d</option>
                    <option value="14">14d</option>
                    <option value="21">21d</option>
                    <option value="30">30d</option>
                    <option value="60">60d</option>
                    <option value="90">90d</option>
                    <option value="180">180d</option>
                </select>
                <i class="fa fa-sync-alt fa-spin" v-if="isSavingSnooze"></i>
                <i class="fa fa-spinner fa-spin" v-if="isLoadingSnooze"></i>
                </span>
            </p>

            <div class="table-responsive">
                <table class="table">
                    <tr>
                        <th>Previous Value</th>
                        <th>Value</th>
                        <th>Total Value</th>
                        <th>Percent</th>
                    </tr>
                    <tr>
                        <td>{{ notification.previous_value }}</td>
                        <td>{{ notification.value }}</td>
                        <td>{{ notification.total_value }}</td>
                        <td>{{ notification.percent }} <span v-show="hasPercentType">({{ getPercentType() }})</span>
                        </td>
                    </tr>
                    <tr>
                        <th>Feed Size</th>
                        <th>Online Count</th>
                        <th>Quota</th>
                        <th></th>
                    </tr>
                    <tr>
                        <td>{{ notification.feed_size }}</td>
                        <td>{{ notification.online_count }}</td>
                        <td>{{ notification.quota }}</td>
                        <td></td>
                    </tr>
                </table>
            </div>
            <p>
                <strong>Feed Active: </strong> {{ notification.agency.is_feed_active ? 'Yes' : 'No' }}
            </p>
            <p>
                <strong>Feed Url(s):</strong>
                <span v-for="feed_url in getAgencyFeedUrls">
                    <br/><a :href="feed_url" target="_blank">{{ feed_url }}</a>
                </span>
            </p>
            <p>
                <strong>Data: </strong>
                <a href="#" @click.prevent="showData" v-show="show_data === false">Show</a>
                <a href="#" @click.prevent="hideData" v-show="show_data === true">Hide</a>
            </p>
            <pre v-show="show_data === true">{{ notification.data }}</pre>

            <div class="row">
                <div class="col-sm-12">
                    <strong>Agency Notes (sales) <i class="fa fa-sync-alt fa-spin" v-if="isSavingNotes"></i> <i
                        class="fa fa-spinner fa-spin" v-if="isLoadingNotes"></i></strong><br>

                    <textarea v-model="agency_notes_sales" :disabled="isLoadingNotes" @change="saveNotes(notification)" rows="4"
                              class="form-control" style="min-width: 100%"></textarea>
                </div>
                <div class="col-sm-12">
                    <strong>Agency Notes (systems) <i class="fa fa-sync-alt fa-spin" v-if="isSavingNotes"></i> <i
                        class="fa fa-spinner fa-spin" v-if="isLoadingNotes"></i></strong><br>
                    <textarea v-model="agency_notes_systems" :disabled="isLoadingNotes" @change="saveNotes(notification)" rows="4"
                              class="form-control" style="min-width: 100%"></textarea>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "notification-more-info-modal",
    props: ['notification', 'statuses', 'environment'],
    data() {
        return {
            show_data: false,
            isSavingStatus: false,
            isSavingSnooze: false,
            isSavingNotes: false,
            isLoadingSnooze: true,
            isLoadingNotes: true,
            snooze_select_days: '',
            snoozed_until_days: null,
            agency_notes_sales: null,
            agency_notes_systems: null,
        };
    },
    mounted() {
        this.loadAgencyNotes();
        this.loadSnooze();
    },
    computed: {
        advertsUrl() {
            let url = this.environment === 'local'
                ? 'http://french-property.test/properties-for-sale?agency='
                : 'https://www.french-property.com/properties-for-sale?agency=';
            return this.appendAgencyId(url);
        },
        reportsUrl() {
            let url = this.environment === 'local'
                ? 'http://config.french-property.test/feed_manager/feed_reports/'
                : 'https://config.french-property.com/feed_manager/feed_reports/';
            return this.appendAgencyId(url);
        },
        getAgencyFeedUrls() {
            if (this.notification.agency.feed_url == null) {
                return [];
            }
            return this.notification.agency.feed_url.split(/\r?\n/);
        },
        hasPercentType() {
            return (this.notification.percent_type_id !== null && this.notification.percent_type_id !== undefined);
        },
        hasLogsLink() {
            return this.notification.data.hasOwnProperty('link');
        },
        logsLink() {
            return this.hasLogsLink ? this.notification.data.link : '';
        },
    },
    methods: {
        loadSnooze() {
            this.isLoadingSnooze = true;
            axios.get('/notifier/' + this.notification.id + '/check-snoozed')
                .then(response => {
                    if (response.data['snoozed']) {
                        this.snoozed_until_days = response.data['days'];
                    }
                    this.isLoadingSnooze = false;
                    this.$forceUpdate();
                });
        },
        loadAgencyNotes() {
            this.isLoadingNotes = true;
            axios.get('/notifier/agency/' + this.notification.agency_id + '/data')
                .then(response => {
                    this.agency_notes_sales = response.data['notes_sales'];
                    this.agency_notes_systems = response.data['notes_systems'];
                    this.isLoadingNotes = false;
                    this.$forceUpdate();
                });
        },
        appendAgencyId(url) {
            return url + this.notification.agency_id;
        },
        showData() {
            this.show_data = true;
        },
        hideData() {
            this.show_data = false;
        },
        getPercentType() {
            if (this.hasPercentType) {
                return this.notification.percent_type.type;
            }

            return '';
        },
        saveStatus() {
            this.isSavingStatus = true;
            axios.post('/notifier/' + this.notification.id + '/update-status', {'status_id': this.notification.status_id})
                .then(response => {
                    this.notification.status = this.getStatusObjectInNotificationStructure(this.notification.status_id);
                    this.isSavingStatus = false;
                });
        },
        saveSnooze(notification) {
            this.isSavingSnooze = true;
            console.log(this.snooze_select_days);

            axios.post('/notifier/' + notification.id + '/snooze', {
                "snooze_days": this.snooze_select_days,
            }).then(response => {
                if (response.data.status === 'ok') {
                    this.isSavingSnooze = false;
                    this.notification.snooze_clicked = true;
                    this.snoozed_until_days = this.snooze_select_days;
                    this.$forceUpdate();
                } else {
                    console.log('Saving snooze: response.data.status not ok');
                    console.log(response);
                }
            });
        },
        saveNotes(notification) {
            // console.log("save notes...");

            this.isSavingNotes = true;

            axios.post('/notifier/agency/' + notification.agency.id + '/notes/edit', {
                "notes_sales": this.agency_notes_sales,
                "notes_systems": this.agency_notes_systems,
            }).then(response => {
                if (response.data.status === 'ok') {
                    // console.log("notes saved");
                    this.isSavingNotes = false;
                } else {
                    console.log('Saving notes: response.data.status not ok');
                    console.log(response);
                }
            });
        },
        getStatusById(id) {
            return this.statuses.find(s => s.id === id);
        },
        getStatusObjectInNotificationStructure(status_id) {
            let status = this.statuses.find(s => s.id === status_id);
            return {
                id: status.id,
                name: status.label
            };
        }
    }
}
</script>

<style scoped>

</style>
